export default "__VITE_ASSET__7036cbc6__"